import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { askedFor, tiredOf } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-navy selection:bg-lav-soft selection:text-navy" data-id="element-0" data-mp="3iiwf2oflbi38">
      <MetaPixel data-id="element-1" data-mp="3mk83wrqn3zad" />
      <main data-id="element-2" data-mp="3mjpyp5m02aqb">
        <Hero data-id="element-3" data-mp="3mj6jvxrnc2gi" />
        <SocialProofBar data-id="element-4" data-mp="3rcj5s04xxv5k" />
        <PainGrid data-id="element-5" data-mp="3rbzq6q2rjiup" />
        <ProductReveal data-id="element-6" data-mp="3rdkkqfp2v1sk" />
        <Tomes data-id="element-7" data-mp="3recdlirailf5" />
        <Bonuses data-id="element-8" data-mp="5yj0slx59ec" />
        <LookInside data-id="element-9" data-mp="6hr7hlrojf6" />
        <ValueStack data-id="element-10" data-mp="4wwnrzgd0hb" />
        <Urgency data-id="element-11" data-mp="5gbgztt38r4" />
        <Pricing data-id="element-12" data-mp="82ohezguggq" />
        <Testimonials testimonials={askedFor} eyebrow="We read the reviews first" title="What counselors said was missing" subtitle="Before writing a single session, we read what professionals say about the art therapy books and worksheet packs they already bought. These are their words about other resources, not reviews of this pack. Every session was built to answer them." background="white" data-id="element-13" data-mp="2zl3dbpgpde7f" />
        <Guarantee data-id="element-14" data-mp="nv0x5qhcgk43" />
        <Faq data-id="element-15" data-mp="nxn9e3f6jnsn" />
        <Testimonials testimonials={tiredOf} eyebrow="And what they were tired of" title="Coloring pages, ice-breakers, the same ideas" subtitle="More reviewer comments on other resources. This is the gap the 4-Step Session Arc closes." background="blush" data-id="element-16" data-mp="sunadzx6a0cw" />
        <CostOfInaction data-id="element-17" data-mp="d57hf8hvkslp" />
        <Close data-id="element-18" data-mp="d3mi75km8lhi" />
      </main>
      <Footer data-id="element-19" data-mp="d3waizt4v4qd" />
      <PurchaseNotifications data-id="element-20" data-mp="d2bhjemgvtum" />
    </div>;
}